import React from "react";
import {Box, styled, Typography} from "@mui/material";
import {IKImage} from 'imagekitio-react';
import {ISize} from "../../interfaces/components/utility/ISize";

const StyledIKImage = styled(IKImage)(({theme}) => ({
    maxWidth: '100%',
    borderRadius: theme.spacing(1), // todo
    imageRendering: '-webkit-optimize-contrast',
}));

interface IProps {
    size?: ISize;
    image: string;
    description?: string;
}

function ProjectImage(props: IProps) {
    const {size, image, description} = props;

    const style = size ? {
        width: size.width,
        // maxHeight: size.height,
    } : {width: '100%'};


    return <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        alignSelf='center'
        sx={{
            minHeight: 'auto',
        }}
        maxWidth={'md'}
    >
        <StyledIKImage
            id={'ProjectImage'}
            path={image}
            loading="lazy"
            lqip={{active: true}}
            alt={image}
            src={image}
            style={style}
        />
        {description ?
            <Typography
                id={'ImageName'}
                variant={"subtitle1"}
                sx={{
                    textAlign: 'center',
                    fontStyle: 'italic',
                }}
            >
                {description}
            </Typography>
            : null
        }
    </Box>
}


export default ProjectImage;
